import { XHRAuthorizedClient } from '@/remote/client';
import { ENDPOINTS } from '@/remote/endpoints';
import { QUERY_KEYS } from '@/remote/query-key';
import type {
  SiteInspectionResponse,
  SiteInspectionsApiResponse,
} from '@/types/site';
import { useSuspenseQuery } from '@tanstack/react-query';

// 모든 점검 기록 조회 (접근 가능한 사이트만)
export const useInspectionsQuery = () => {
  return useSuspenseQuery({
    queryKey: QUERY_KEYS.inspections.getList,
    queryFn: async (): Promise<SiteInspectionResponse[]> => {
      const response =
        await XHRAuthorizedClient.get<SiteInspectionsApiResponse>(
          ENDPOINTS.inspections.list
        );
      return response.data.data;
    },
  });
};

// 특정 사이트의 점검 기록 조회
export const useInspectionsBySiteQuery = (siteId: string) => {
  return useSuspenseQuery({
    queryKey: QUERY_KEYS.inspections.getBySite(siteId),
    queryFn: async (): Promise<SiteInspectionResponse[]> => {
      const response =
        await XHRAuthorizedClient.get<SiteInspectionsApiResponse>(
          ENDPOINTS.inspections.bySite(siteId)
        );
      return response.data.data;
    },
  });
};
